/* global ValidatePageItems */

(function($) {
    'use strict';
    var Accordion = function(el, options) {
        this.settings = options;
        this.$el = $(el);
        this.$items = this.$el.find('> .accordion-item, > span > .accordion-item');
        this.$titles = this.$items.find('> .accordion-title, > span > .accordion-title');
        // If accordion is within a align-height container
        // It needs to calculate its maxHeight on resize
        // For Tena.Alignment to set the right height
        this.shouldSetMaxHeight = this.$el.closest('.align-height').size();
        this.prependArrow = this.$el.hasClass('accordion-prepend-arrow');
        this.keepItemsOpen = this.$el.hasClass('accordion-keep-open');
        this.init();
    };
    Accordion.prototype = {
        init: function() {
            var that = this,
                $firstItem = that.$items.first();
            if ($firstItem.find('> .accordion-content').css('display') === 'none') {
                $firstItem.addClass('accordion-collapsed');
            }
            $firstItem.attr('class', function(index, attribute) {
                return attribute.replace(/(^|\s)accordion-collapsed-\S+/g, '');
            });
            that.$titles.each(function() {
                var $icon = $(this).find('i'),
                    arrow = '<i class="icon-arrow-down"></i>';
                if (!$icon.size() && !that.$el.hasClass('accordion-no-icon')) {
                    if (that.prependArrow) {
                        $(this)
                            .wrapInner('<span class="accordion-title-content"></span>')
                            .prepend(arrow);
                    } else {
                        $(this).append(arrow);
                    }
                }
            });
            that.$items.each(function() {
                var $item = $(this);
                if (!$item.hasClass('accordion-expanded')) {
                    $item.addClass('accordion-collapsed');
                }
            });
            that.bindEvents();
            if (that.shouldSetMaxHeight) {
                that.$el.addClass('dynamic-height');
            }
        },
        bindEvents: function() {
            var that = this;
            that.$el.on(
                'click',
                '> .accordion-item > .accordion-title, > .accordion-item > span > .accordion-title, > span > .accordion-item .accordion-title',
                function(e) {
                    var $this = $(this),
                        // $item = $this.parent();
                        $item = $this.closest('.accordion-item'),
                        disableClass = $item.attr('data-accordion-disable');
                    // Disable click on specific element
                    // Example:
                    // <div class="accordion-item" data-accordion-disable="field-checkbox-container">
                    if (disableClass) {
                        if (
                            $(e.target).hasClass(disableClass) ||
                            $(e.target).parents().hasClass(disableClass)
                        ) {
                            return;
                        }
                    }
                    if ($item.hasClass('accordion-inactive')) {
                        return;
                    }
                    if ($item.hasClass('accordion-expanded')) {
                        that.contract($item);
                    } else {
                        that.expand($item);
                    }

                    return false;
                }
            );
            that.$el.find('.js-accordion-continue').on('click', function() {
                var $currentItem = that.$items.filter('.accordion-expanded:last'),
                    currentIndex = that.$items.index($currentItem),
                    $nextItem = that.$items.eq(currentIndex + 1);
                if ($(this).hasClass('validate-form')) {
                    var valid = ValidatePageItems(this);
                    if (!valid) {
                        return false;
                    }
                }
                $currentItem.addClass('accordion-inactive');
                $nextItem.removeClass('accordion-inactive');
                that.contract($currentItem);
                that.expand($nextItem);

                return false;
            });
            if (that.shouldSetMaxHeight) {
                $(window).on('resize', function() {
                    that.setMaxHeight();
                });
                that.setMaxHeight();
            }
        },
        setMaxHeight: function() {
            var maxHeight = 0,
                that = this,
                $currentItem = that.$items.filter('.accordion-expanded');
            $currentItem.removeClass('accordion-expanded');
            that.$items.each(function() {
                var $item = $(this);
                $item.addClass('accordion-expanded');
                if (that.$el.outerHeight(true) > maxHeight) {
                    maxHeight = that.$el.outerHeight(true);
                }
                $item.removeClass('accordion-expanded');
            });
            $currentItem.addClass('accordion-expanded');
            that.$el.attr('data-dynamic-height', maxHeight);
        },
        expand: function($item) {
            var $content = $item.find('> .accordion-content'),
                that = this,
                height,
                $icon = $item.find('> .accordion-title i, > span > .accordion-title i'),
                scrollTop = that.getScrollPosition($item);
            if (!that.keepItemsOpen) {
                that.$items.filter('.accordion-expanded').each(function() {
                    that.contract($(this));
                });
            }
            $icon.removeClass('icon-arrow-down').addClass('icon-arrow-up');
            $item.addClass('accordion-expanded').removeClass('accordion-collapsed');
            height = $content.height();
            if (scrollTop) {
                $(document).scrollTop(scrollTop);
            }
            $content
                .css({
                    height: 27
                })
                .animate(
                    {
                        height: height
                    },
                    function() {
                        $content.css({ height: '' });
                    }
                );

            $.event.trigger('accordion.changed', {
                show: $item
            });
        },
        contract: function($item) {
            var $content = $item.find('> .accordion-content'),
                $icon = $item.find('> .accordion-title i, > span > .accordion-title i');

            $content
                .css({
                    height: $content.height()
                })
                .animate(
                    {
                        height: 27
                    },
                    function() {
                        $content.css({ height: '' });
                        $icon.removeClass('icon-arrow-up').addClass('icon-arrow-down');
                        $item
                            .removeClass('accordion-expanded')
                            .addClass('accordion-collapsed');
                    }
                )
                .delay();
        },
        getScrollPosition: function($item) {
            var that = this,
                $current = that.$items.filter('.accordion-expanded'),
                currentHeight = $current.find('> .accordion-content').height(),
                currentIndex = that.$items.index($current),
                itemIndex = that.$items.index($item),
                $itemBefore = that.$items.eq(itemIndex - 1),
                scrollPos = 0,
                currentScrollPos = $(window).scrollTop(),
                menuHeight = 70;
            if (itemIndex > currentIndex) {
                scrollPos = $item.offset().top - currentHeight - menuHeight;
            } else {
                scrollPos = $item.offset().top - menuHeight;
            }
            if (currentScrollPos < scrollPos) {
                scrollPos = false;
            }
            if (scrollPos && itemIndex > 0 && $itemBefore.size()) {
                scrollPos = $itemBefore.offset().top - menuHeight;
            }

            return scrollPos;
        }
    };
    $.fn.accordion = function(options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function() {
            $this = $(this);
            data = $this.data('accordion');
            if (!data) {
                $this.data('accordion', (data = new Accordion(this, options)));
            }
            if (typeof options === 'string') {
                data[options](args);
            }
        });
    };
    $.fn.accordion.Constructor = Accordion;
})(jQuery);
